import {clsx, type ClassValue} from "clsx"
import {twMerge} from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
    return twMerge(clsx(inputs))
}

const WO_PLATFORM_FEE_PERCENT = 15;

export interface CompanyBilledAmountOutput {
    platformCharge: number // @15%
    gst: number // @18%
    // companyBilledAmount: number
    totalPayable: number
}

export function limitDecimals(num, dec) {
    const power = 10 ** dec;
    return Math.floor(num * power) / power;
}

export function getCompanyBilledAmountFromInfluencerRate(infRate: number) : CompanyBilledAmountOutput {
    const companyRate = infRate / (100 - WO_PLATFORM_FEE_PERCENT) * 100;
    const platformCharge = companyRate - infRate;

    return {
        platformCharge: limitDecimals(platformCharge, 2),
        gst: limitDecimals(companyRate * 0.18, 2),
        totalPayable: limitDecimals(companyRate * 1.18, 2),
        // companyBilledAmount: companyRate,
    };
}

